const FinlandFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="20" fill="#FFFFFF"/>
    <rect x="13" width="4" height="20" fill="#003580"/>
    <rect y="8" width="30" height="4" fill="#003580"/>
  </svg>
);

export default FinlandFlag;